module.exports = __webpack_public_path__ + "static/img/sfzsl.8edd104.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/sfzsl.jpg
// module id = j7Si
// module chunks = 1